import { atom } from "recoil"
import { ContactFilterValue } from "src/types/contact/ContactFilter"

export const defaultContactFilterState = atom<ContactFilterValue[] | undefined>({
  key: "atoms/contact/defaultContactFilterState",
  default: undefined,
})
